<template>
  <div class="projectsWrap">
    <div class="searchWrap">
      <span class="label"> {{ $tt("工程名称：") }} </span>
      <el-input
        v-model="searchValue"
        clearable 
        :placeholder="$tt('请输入工程名称')"
      ></el-input>
      <el-button type="primary" icon="el-icon-search" @click="search"
        >{{ $tt("搜索") }}</el-button
      >
    </div>
    <div class="toolbarOperations">
      <el-button
        size="mini"
        v-for="t in toolbarOperations"
        :key="t.key"
        :type="t.key == 'delete' ? 'danger' : 'primary'"
        @click="operationHandler(t.key)"
        >{{ $tt(t.text) }}</el-button
      >
    </div>
    <ProjectListPreview
      :visible="previewVisible"
      :project-id="previewProjectId"
      @close="onPreviewClose"
    />
    <MoveDialog
        v-if="moveVisible"
        :visible="moveVisible"
        :switchDialogVisible="switchDialogVisible"
        :refresh="refresh"
        :projectIds="projectIds"
    />
    <el-table
      :data="tableDataInfo.result"
      style="width: 100%"
      class="projectsTable"
      border
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        v-for="c in tableColumns"
        :key="c.prop"
        :label="$tt(c.label)"
        :width="$listColWidth(c)"
        :min-width="$listColMinWidth(c)"
        :prop="$listColProp(c)"
        :sortable="$listSortable(c)"
        :class-name="$listColClass(c)"
        :label-class-name="$listColClass(c)"
        :fixed="$listColFixed(c)"
        :show-overflow-tooltip="$listOverflow(c)"
      >
        <template slot-scope="scope">
          <div v-if="c.prop.indexOf('time') > -1">
            {{ dateTransform(scope.row[c.prop]) }}
          </div>
          <div v-else-if="c.prop == 'project_img'">
            <img
              class="projectImg"
              v-if="scope.row[c.prop]"
              :src="scope.row[c.prop]"
            />
          </div>
          <div v-else-if="c.prop == 'type'">
            {{ $tt(getLevelName(scope.row.type)) }}
          </div>
          <div class="table-ops" v-else-if="c.prop == 'operations'">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handlePreview(scope.row)"
            >
              {{ $tt("预览") }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            >
              {{ $tt("编辑") }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-picture"
              @click="handleUploadImage(scope.row.id)"
            >
              {{ $tt("上传图片") }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-share"
              @click="showShareDialog(scope.row)"
            >
              {{ $tt("分享") }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-upload2"
              :loading="exportLoad && editableRows.includes(scope.$index)"
              :disabled = "scope.row.package_path === '' ||scope.row.package_path === null  ? false : true"
              @click="exportProjects(scope.row,scope.$index)"
            >
              {{ $tt("导出") }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-download"
              :disabled = "scope.row.package_path === '' ||scope.row.package_path === null || scope.row.package_path === 'done' ? true : false"
              @click="downloadProjects(scope.row)"
            >
              {{ $tt("下载") }}
            </el-button>
            <span
              v-if="scope.row.package_path === 'done'"
              class="export-progress-text"
            >
              {{ $tt("导出中") }} {{ Number(scope.row.export_progress) || 0 }}%
            </span>
          </div>
          <span v-else>{{ scope.row[c.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-if="tableDataInfo.total > 8"
      :pageNum="pageNum"
      :handleSizeChange="
        (v) => {
          this.pageNum = 1;
          this.pageSize = v;
          this.getTableData({ page_size: v });
        }
      "
      :handleCurrentPageChange="
        (v) => {
          this.pageNum = v;
          this.getTableData({ page_num: v });
        }
      "
      :total="tableDataInfo.total"
    />

    <!-- 图片资源的modal -->
    <ImagesResourceModal
      ref="imagesResourceModal"
      modalOperationKey="other"
      :confirm="changeProjectImage"
    />
    <el-dialog
      :title="chooseDialogTitle"
      :visible="dialogVisible"
      width="360px"
      :center="dialogType == 'share'"
      custom-class="newProject"
      :before-close="
        () => {
          this.dialogVisible = false;
        }
      "
    >
      <div v-if="dialogType == 'createProject'">
        <div class="level" v-for="l in projectLevels" :key="l.id">
          <span>{{ $tt(l.project_type) }}{{ $tt("工程") }}</span>
          <span @click="toCreateProject(l)" class="create">{{ $tt("创建") }}</span>
        </div>
      </div>
      <div v-else>
        <el-input
          type="textarea"
          :rows="4"
          :placeholder="$tt('请输入内容')"
          v-model="shareProjectReason"
        />
      </div>
      <span slot="footer" class="shareFooter" v-if="dialogType == 'share'">
        <el-button type="primary" @click="shareProject">{{ $tt("分享") }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
    :title="$tt('导入智探现场工程')"
      :visible.sync="importProbeVisible"
      width="480px"
      custom-class="importProbeDialog"
      :before-close="closeImportProbeDialog"
    >
      <p class="importProbeTip">
        说明：从 WeTab 智探「导出给 Cloud」的 JSON 导入。画布上绑定的指令若云端指令库没有，会自动录入当前账号，无类型的归入
        <b>default</b>；之后可在「私有资源 / 指令」编辑页切换类型。
      </p>
      <div class="importProbeField">
        <span class="importProbeLabel">{{ $tt("JSON 文件") }}</span>
        <input
          ref="probeFileInput"
          type="file"
          accept=".json,application/json"
          @change="onProbeFileChange"
        />
      </div>
      <div v-if="importProbePreview" class="importProbePreview">
        <div>{{ $tt("工程名称：") }}{{ importProbePreview.project_name || '-' }}</div>
        <div>
          {{ $tt("画布尺寸：") }}{{ importProbePreview.project_width || '-' }} ×
          {{ importProbePreview.project_height || '-' }}
        </div>
        <div>{{ $tt("页面数量：") }}{{ importProbePreview.pageCount }}</div>
      </div>
      <div class="importProbeField">
        <span class="importProbeLabel">{{ $tt("工程等级") }}</span>
        <el-select
          v-model="importProbeLevelCode"
          :placeholder="$tt('请选择工程等级')"
          style="width: 100%"
        >
          <el-option
            v-for="l in projectLevels"
            :key="l.id"
            :label="$tt(l.project_type) + $tt('工程')"
            :value="l.project_code"
          />
        </el-select>
      </div>
      <div class="importProbeField">
        <span class="importProbeLabel">{{ $tt("工程名称") }}</span>
        <el-input
          v-model="importProbeName"
          clearable
          :placeholder="$tt('可修改导入后的工程名称')"
        />
      </div>
      <span slot="footer">
        <el-button @click="closeImportProbeDialog">{{ $tt("取消") }}</el-button>
        <el-button
          type="primary"
          :loading="importProbeLoading"
          @click="importProbeConfirm"
        >
          {{ $tt("确认导入") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import MoveDialog from './moveDialog.vue'
import ImagesResourceModal from "@/components/ImagesResourceModal";
import Pagination from "@/components/Pagination";
import {downloadFileByBlob, uuid, setCookie} from '@/utils/utils';
import { applyAccountQuotaToLogin } from "@/utils/account";
import ProjectListPreview from "@/components/Projects/ProjectListPreview.vue";
export default {
  data() {
    return {
      previewVisible: false,
      previewProjectId: "",
      editableRows: [],
      exportLoad:false,
      /** 导出进度轮询定时器 */
      exportPollTimer: null,
      moveVisible:false,
      projectIds:[],
      tableColumns: [
        {
          label: "工程名称",
          prop: "project_name",
          sortable: true
        },
        {
          label: "工程图片",
          prop: "project_img",
          width: 200,
          sortable: false
        },
        {
          label: "画布宽度",
          prop: "project_width",
          width: 100,
          sortable: false
        },
        {
          label: "画布高度",
          prop: "project_height",
          width: 100,
          sortable: false
        },
        {
          label: "工程属性",
          prop: "type",
          width: 120,
          sortable: false
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: 130,
          sortable: true
        },
        {
          label: "修改时间",
          prop: "update_time",
          width: 130,
          sortable: true
        },
        {
          label: "操作",
          prop: "operations",
          width: "420",
          sortable: false
        },
      ],
      tableDataInfo: {},
      searchValue: "",
      dialogVisible: false,
      toolbarOperations: [
        {
          text: "新建工程",
          key: "new",
        },
        // {
        //   text: "导入智探画布",
        //   key: "importProbe",
        // },
        {
          text: "工程复制",
          key: "copy",
        },
        {
          text: "工程删除",
          key: "delete",
        },
        {
          text: "工程交接",
          key: "move",
        },
        // {
        //   text: "导出",
        //   key: "export",
        // },
      ],
      activeProjectId: "",
      dialogType: "",
      shareProjectReason: "",
      selectedProjects: [],
      pageNum: 1,
      pageSize: 8,
      importProbeVisible: false,
      importProbeLoading: false,
      importProbeRaw: null,
      importProbePreview: null,
      importProbeLevelCode: "",
      importProbeName: "",
    };
  },
  components: {
    ImagesResourceModal,
    Pagination,
    MoveDialog,
    ProjectListPreview,
  },
  mounted() {
    this.getTableData({});
    this.$store.dispatch("getProjectLevelsAction", {});
    this.refreshAccountQuota();
    document.addEventListener("visibilitychange", this.onQuotaVisibility);
  },
  activated() {
    this.refreshAccountQuota();
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.onQuotaVisibility);
    this.stopExportProgressPoll();
  },
  computed: {
    ...mapState(["loginAccountInfo", "projectLevels"]),
    chooseDialogTitle() {
      return this.dialogType == "share" ? "分享" : "新建工程";
    },
  },
  methods: {
    switchDialogVisible(bol) {
      this.moveVisible = bol
      this.selectedProjects=[]
      this.search()
    },
    getLevelName(l) {
      const level =
        this.projectLevels.find((item) => item.project_code == l) || {};
      return level.project_type || this.$tt("未知属性");
    },
    onQuotaVisibility() {
      if (document.visibilityState === "visible") {
        this.refreshAccountQuota();
      }
    },
    refreshAccountQuota() {
      const info = this.loginAccountInfo || {};
      if (info.is_manage || !this.$request.getProfile) {
        return Promise.resolve();
      }
      return this.$request.getProfile().then((res) => {
        if (res && res.status == "success" && res.data) {
          applyAccountQuotaToLogin(this.$store, setCookie, res.data);
        }
      }).catch(() => {});
    },
    accountProjectQuotaOk(add) {
      const info = this.loginAccountInfo || {};
      const max = Number(info.projects || 0);
      const used = Number((this.tableDataInfo && this.tableDataInfo.total) || 0);
      if (max > 0 && used + add > max) {
        this.$message.error(`工程数量已达账号上限 ${max}（当前 ${used}）`);
        return false;
      }
      return true;
    },
    operationHandler(key) {
      if (key == "new") {
        this.dialogType = "createProject";
        this.dialogVisible = true;
      } else if (key === "importProbe") {
        this.openImportProbeDialog();
      } else if (key == "delete") {
        this.deleteProjects();
      } else if (key === 'copy') {
        this.copyProjects();
      // } else if (key === 'export') {
      //   this.exportProjects();
        } else if (key === 'move') {
          this.MoveProjects();
      }
    },
    openImportProbeDialog() {
      this.importProbeVisible = true;
      this.importProbeLoading = false;
      this.importProbeRaw = null;
      this.importProbePreview = null;
      this.importProbeLevelCode = "";
      this.importProbeName = "";
      this.$nextTick(() => {
        if (this.$refs.probeFileInput) {
          this.$refs.probeFileInput.value = "";
        }
      });
    },
    closeImportProbeDialog(done) {
      this.importProbeVisible = false;
      this.importProbeLoading = false;
      this.importProbeRaw = null;
      this.importProbePreview = null;
      this.importProbeLevelCode = "";
      this.importProbeName = "";
      if (this.$refs.probeFileInput) {
        this.$refs.probeFileInput.value = "";
      }
      if (typeof done === "function") done();
    },
    onProbeFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const raw = JSON.parse(reader.result);
          if (!raw || typeof raw !== "object") {
            throw new Error("invalid json");
          }
          let pageSort = raw.page_sort;
          if (typeof pageSort === "string") {
            try {
              pageSort = JSON.parse(pageSort);
            } catch (err) {
              pageSort = pageSort ? [pageSort] : [];
            }
          }
          if (!Array.isArray(pageSort)) {
            pageSort = [];
          }
          let pageCount = pageSort.length;
          if (!pageCount) {
            pageCount = this.countProbePages(raw.panel_data);
          }
          this.importProbeRaw = raw;
          this.importProbeName = raw.project_name || "";
          this.importProbePreview = {
            project_name: raw.project_name || "",
            project_width: raw.project_width || "",
            project_height: raw.project_height || "",
            pageCount,
          };
        } catch (err) {
          this.importProbeRaw = null;
          this.importProbePreview = null;
          this.importProbeName = "";
          this.$message.error("JSON 解析失败，请选择智探导出的有效文件");
        }
      };
      reader.onerror = () => {
        this.$message.error("文件读取失败");
      };
      reader.readAsText(file, "utf-8");
    },
    countProbePages(panelData) {
      if (panelData == null) return 0;
      let data = panelData;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (err) {
          return 0;
        }
      }
      if (Array.isArray(data)) return data.length;
      if (data && typeof data === "object") return Object.keys(data).length;
      return 0;
    },
    normalizeProbePageSort(pageSort) {
      if (typeof pageSort === "string") {
        try {
          pageSort = JSON.parse(pageSort);
        } catch (err) {
          pageSort = pageSort ? [pageSort] : [];
        }
      }
      return Array.isArray(pageSort) ? pageSort : [];
    },
    normalizeProbePanelData(panelData) {
      if (panelData == null) return "{}";
      if (typeof panelData === "string") return panelData;
      return JSON.stringify(panelData);
    },
    normalizeProbeInteractionData(interactionData) {
      if (interactionData == null) return "[]";
      if (typeof interactionData === "string") return interactionData;
      return JSON.stringify(interactionData);
    },
    async importProbeConfirm() {
      if (!this.importProbeRaw) {
        this.$message.error("请先选择并解析 JSON 文件");
        return;
      }
      await this.refreshAccountQuota();
      if (!this.accountProjectQuotaOk(1)) {
        return;
      }
      if (!this.importProbeLevelCode) {
        this.$message.error("请选择工程等级");
        return;
      }
      const projectName = (this.importProbeName || "").trim();
      if (!projectName) {
        this.$message.error("请填写工程名称");
        return;
      }
      const raw = this.importProbeRaw;
      const page_sort = this.normalizeProbePageSort(raw.page_sort);
      const panel_data = this.normalizeProbePanelData(raw.panel_data);
      const interaction_package_data = this.normalizeProbeInteractionData(
        raw.interaction_package_data
      );
      const payload = {
        type: this.importProbeLevelCode,
        project_name: projectName,
        project_width: String(raw.project_width || ""),
        project_height: String(raw.project_height || ""),
        page_sort,
        panel_data,
        interaction_package_data,
        source: raw.source || "",
      };

      this.importProbeLoading = true;
      this.$changeLoadingState(true);
      let createdProject = null;
      try {
        let res;
        try {
          res = await this.$request.importProbePanel(payload);
          if (res.status != "success") {
            throw new Error(res.msg || "importProbePanel failed");
          }
        } catch (apiErr) {
          // 后端导入接口不可用时，回退到 addOrUpdate 直接创建工程
          res = await this.$request.appOrUpdateProject({
            id: "",
            type: payload.type,
            project_name: payload.project_name,
            project_width: payload.project_width,
            project_height: payload.project_height,
            page_sort: payload.page_sort,
            panel_data: payload.panel_data,
            interaction_package_data: payload.interaction_package_data,
          });
          if (res.status != "success") {
            this.$message.error(res.msg || "导入失败");
            return;
          }
        }
        createdProject = res.data || {};
        this.$message.success(res.msg || "导入成功");
        this.closeImportProbeDialog();
        this.getTableData({
          project_name: this.searchValue,
        });
        if (createdProject.id) {
          this.$confirm(this.$tt("导入成功，是否立即打开编辑器？"), this.$tt("提示"), {
            confirmButtonText: this.$tt("打开编辑"),
            cancelButtonText: this.$tt("稍后"),
            type: "success",
          })
            .then(() => {
              this.handleEdit({
                id: createdProject.id,
                type: payload.type,
              });
            })
            .catch(() => {});
        }
      } catch (error) {
        this.$message.error(
          (error && error.message) || "导入失败，请检查文件或稍后重试"
        );
      } finally {
        this.importProbeLoading = false;
        this.$changeLoadingState(false);
      }
    },
    async exportProjects(row,rowIndex) {
      this.exportLoad = true
      this.editableRows.push(rowIndex);
      // if (_.isEmpty(this.selectedProjects)) {
      //   this.$message.error("请选择工程");
      //   return;
      // }
      // 工程导出
      this.$changeLoadingState(true);
      try {
        const res = await this.$request.exportByProjectId({
          id: row.id
        });
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("正在后台打包中......工程打包时长与工程体积大小有关！请您耐心等待!");
        // 乐观更新当前行进度，便于立刻展示
        if (row) {
          this.$set(row, "package_path", "done");
          this.$set(row, "export_progress", (res.data && res.data.export_progress) || 5);
        }
        this.getTableData({
          project_name: this.searchValue,
        });
        this.startExportProgressPoll();
      } catch (error) {
        this.$message.error(
          (error && error.message) || "打包失败！请联系网站开发者！"
        );
      } finally {
        const index = this.editableRows.indexOf(rowIndex);
        if (index !== -1) {
          this.editableRows.splice(index, 1);
        }
        this.exportLoad = false;
        this.$changeLoadingState(false);
      }
    },
    startExportProgressPoll() {
      if (this.exportPollTimer) {
        return;
      }
      this.exportPollTimer = setInterval(() => {
        this.getTableData({
          project_name: this.searchValue,
        });
      }, 2000);
    },
    stopExportProgressPoll() {
      if (this.exportPollTimer) {
        clearInterval(this.exportPollTimer);
        this.exportPollTimer = null;
      }
    },
    syncExportPollByTable() {
      const list = (this.tableDataInfo && this.tableDataInfo.result) || [];
      const hasExporting = list.some((item) => item.package_path === "done");
      if (hasExporting) {
        this.startExportProgressPoll();
      } else {
        this.stopExportProgressPoll();
      }
    },
    downloadProjects(row) {
      const path = row.package_path;
          if (!path) {
            this.$message.error('此工程未行打包或者打包未完成！请执行打包或等待！');
            this.$changeLoadingState(false);
            return;
      }
      window.open(path);
          // downloadFileByBlob('/api/cloud/project/download', JSON.stringify({
          //     path: path
          // }), () => {
          //   this.$changeLoadingState(false);
          // });
    },
    copyProjects() {
      if (_.isEmpty(this.selectedProjects)) {
        this.$message.error("请选择工程");
        return;
      }
      this.refreshAccountQuota().then(() => {
        if (!this.accountProjectQuotaOk(this.selectedProjects.length)) {
          return;
        }
        this.$request
          .copyProjects({ ids: this.selectedProjects.map((item) => item.id) })
          .then((res) => {
            if (res.status != "success") {
              this.$message.error(res.msg);
              return;
            }
            this.getTableData({});
          });
      });
    },
    MoveProjects() {
      if (_.isEmpty(this.selectedProjects)) {
        this.$message.error("请选择工程");
        return;
      }
      this.$confirm(  '<span style="color: red;">交接后您的工程会消失！是否继续？</span><br><span style="font-size: smaller;">如果保留原来工程 请先复制工程再交接</span>',
          '提示',
          {
            confirmButtonText: this.$tt('确定'),
            cancelButtonText: this.$tt('取消'),
            type: 'warning',
            dangerouslyUseHTMLString: true // 允许使用 HTML 字符串
          })
          .then(_ => {
            this.moveVisible = true
            this.projectIds = this.selectedProjects.map((item) => item.id)
          }).catch(() => {
            this.selectedProjects=[]
            this.search()
      });
    },
    deleteProjects() {
      if (_.isEmpty(this.selectedProjects)) {
        this.$message.error("请选择工程");
        return;
      }
      this.$confirm(this.$tt('确认要删除勾选的工程吗？'))
        .then(_ => {
          this.$request
          .deleteProjects({ ids: this.selectedProjects.map((item) => item.id) })
          .then((res) => {
            if (res.status != "success") {
              this.$message.error(res.msg);
              return;
            }
            this.getTableData({});
          });
        });
    },
    changeProjectImage(src) {
      this.$request
        .updateProjectImg({
          project_img: src,
          id: this.activeProjectId,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.$refs.imagesResourceModal.switchDialogVisible(false);
          this.getTableData({});
        });
    },
    refresh(notFirstPage) {
      this.switchDialogVisible(false)
      this.getTableData({});
    },
    handleSelectionChange(val) {
      this.selectedProjects = val;
    },
    toCreateProject(l) {
      this.refreshAccountQuota().then(() => {
        if (!this.accountProjectQuotaOk(1)) {
          return;
        }
        const { pages, project_code, btns, ip_ports } = l;
        const limits = btoa(
          JSON.stringify({ project_code, pages, btns, ip_ports })
        );
        const temporaryId = uuid();
        this.$router.push({
          path: "/projects/add",
          query: {
            limits,
            temporaryId
          },
        });
      });
    },
    getProjectLevelsData() {
      this.$request.getProjectLevelsList({}).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }

        this.projectLevels = res?.data?.result || [];
      });
    },
    getTableData({ project_name, page_num, page_size }) {
      this.$request
        .getProjectsList({
          page_num: page_num || this.pageNum,
          page_size: page_size || this.pageSize,
          project_name
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.tableDataInfo = res.data || {};
          this.syncExportPollByTable();
        });
    },
    handlePreview(row) {
      if (!row || !row.id) {
        return;
      }
      this.previewProjectId = row.id;
      this.previewVisible = true;
    },
    onPreviewClose() {
      this.previewVisible = false;
      this.previewProjectId = "";
    },
    handleEdit(row) {
      const level = this.projectLevels.find(
        (item) => item.project_code == row.type
      );
      if (!level) {
        this.$message.warning("工程等级信息加载中，请稍后重试");
        return;
      }
      const { pages, project_code, btns, ip_ports } = level;

      const limits = btoa(
        JSON.stringify({ project_code, pages, btns, ip_ports })
      );

      this.$router.push({
        path: "/projects/projectsEdit",
        query: {
          limits,
          id: row.id,
        },
      });
    },
    handleUploadImage(id) {
      this.$refs.imagesResourceModal.switchDialogVisible(true);
      this.activeProjectId = id;
    },
    shareProject() {
      this.$request
        .shareProject({
          project_id: this.activeProjectId,
          remark: this.shareProjectReason,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.$message.success("分享成功");
          this.dialogVisible = false;
          this.shareProjectReason = "";
        });
    },
    showShareDialog(row) {
      if (!row.project_img) {
        this.$message.error('工程图片为空，不可分享');
        return;
      }
      this.dialogType = "share";
      this.dialogVisible = true;
      this.activeProjectId = row.id;
    },
    search() {
      this.getTableData({
        project_name: this.searchValue,
      });
    },
    dateTransform(d) {
      if (!d) return;
      return moment(d).format("YYYY-MM-DD HH:mm");
    },
    handleSortChange({ prop, order }) {
      this.sortColumn = prop;
      this.sortOrder = order;

      if (!this.sortColumn || !this.sortOrder) return;

      this.tableDataInfo.result = this.tableDataInfo.result.sort((a, b) => {
        let valA = a[this.sortColumn];
        let valB = b[this.sortColumn];

        // 处理时间字段的排序
        if (this.sortColumn.indexOf('time') > -1) {
          valA = new Date(valA);
          valB = new Date(valB);
        }

        if (valA < valB) {
          return this.sortOrder === "ascending" ? -1 : 1;
        }
        if (valA > valB) {
          return this.sortOrder === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
  },
};
</script>

<style lang='scss'>
.projectsWrap {
  padding: 0 24px 24px;
  background-color: #fff;
  .searchWrap {
    display: flex;
    padding: 16px 0;
    align-items: center;

    .el-input {
      width: 200px !important;
    }
    .el-button {
      margin-left: 16px;
    }
  }
  .toolbarOperations {
    padding-bottom: 16px;
    margin-bottom: 16px;
    .el-button {
      padding: 10px 12px;
    }
  }
  .projectsTable {
    .normal {
      color: #67c23a;
    }
    .table-ops {
      .export-progress-text {
        color: #e6a23c;
        font-size: 12px;
        white-space: nowrap;
        margin-left: 4px;
      }
    }
    .projectImg {
      width: 100px;
      height: 60px;
    }
    .forbid {
      color: #f56c6c;
    }
  }
}
.newProject {
  .el-dialog__body {
    padding: 12px !important;
  }
  .level {
    padding: 6px 60px;

    display: flex;
    justify-content: space-between;
    font-size: 16px;
    .create {
      color: #409eff;
      cursor: pointer;
    }
  }
}
.importProbeDialog {
  .el-dialog__body {
    padding: 12px 20px !important;
  }
  .importProbeTip {
    margin: 0 0 16px;
    color: #909399;
    font-size: 13px;
    line-height: 1.5;
  }
  .importProbeField {
    margin-bottom: 14px;
    .importProbeLabel {
      display: block;
      margin-bottom: 6px;
      color: #606266;
      font-size: 14px;
    }
  }
  .importProbePreview {
    margin-bottom: 14px;
    padding: 10px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    color: #606266;
    font-size: 13px;
    line-height: 1.8;
  }
}
</style>